<template>
  <div v-if="current">
    <v-card width="100%">
      <v-card-title>Dados do registro</v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-md-12 col-sm-1">
              <v-text-field
                label="Contato"
                v-model="current.contact"
                outlined
                dense
                readonly
                append-icon="mdi-account-circle"
                @click:append="dialog_lead = true"
              ></v-text-field>
            </div>
            <div class="col-md-6 col-sm-1">
              <v-text-field
                label="Parceiro recebido"
                v-model="current.partnerReceived"
                outlined
                dense
                readonly
              ></v-text-field>
            </div>
            <div class="col-md-6 col-sm-1">
              <v-select
                label="Parceiro reconhecido"
                v-model="current.partnerKnown"
                :items="partners"
                item-text="name"
                item-value="id"
                outlined
                dense
              ></v-select>
            </div>
            <div class="col-md-6 col-sm-1">
              <v-text-field
                label="Nota recebida"
                v-model="current.scoreReceived"
                outlined
                dense
                readonly
              ></v-text-field>
            </div>
            <div class="col-md-6 col-sm-1">
              <v-text-field
                label="Nota reconhecida"
                v-model="current.scoreKnown"
                outlined
                dense
              ></v-text-field>
            </div>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div>
          <v-btn color="success" @click="save()">Salvar</v-btn>
        </div>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="dialog_lead" max-width="600px">
      <v-card width="100%" v-if="lead">
        <v-card-title>Dados da Lead</v-card-title>
        <v-card-text>
          <v-form>
            <div class="row">
              <div class="col-md-4 col-sm-1">
                <v-text-field
                  label="Contato"
                  v-model="lead.contact"
                  outlined
                  dense
                  disabled
                ></v-text-field>
              </div>
              <div class="col-md-4 col-sm-1">
                <v-text-field
                  label="Nome"
                  v-model="lead.name"
                  outlined
                  dense
                  disabled
                ></v-text-field>
              </div>
              <div class="col-md-4 col-sm-1">
                <v-text-field
                  label="Avatar"
                  v-model="lead.avatar"
                  outlined
                  dense
                  disabled
                ></v-text-field>
              </div>
              <div class="col-md-12 col-sm-1">
                <v-text-field
                  label="Endereço"
                  v-model="lead.address"
                  outlined
                  dense
                  disabled
                ></v-text-field>
              </div>
            </div>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "../../api/index.js";
export default {
  data: () => ({
    current: null,
    partners: [],
    lead: null,
    dialog_lead: false,
  }),
  created: function () {
    this.load();
    this.loadPartners();
  },
  methods: {
    loadLead: function () {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/lead/contact/" + this.current.contact, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.lead = response.data;
        })
        .catch(function () {
          console.log("load fail");
        });
    },
    loadPartners: function () {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/partner", {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.partners = response.data;
        })
        .catch(function () {
          console.log("load fail");
        });
    },
    load: function () {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/nps/" + this.$route.params.id, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.current = response.data;
          me.loadLead();
        })
        .catch(function () {
          console.log("load fail");
        });
    },
    save: function () {
      var token = localStorage.getItem("token");
      api
        .put("/nps/known/" + this.current.id, this.current, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function () {
          alert("Atualizada com sucesso!");
        })
        .catch(function () {
          console.log("save fail");
        });
    },
  },
};
</script>